import { Pill } from "@clipboard-health/ui-components";

import { VisitOccurrenceStatuses } from "../constants";
import { type VisitOccurrenceStatus } from "../types";

interface VisitOccurrencesStatusPillProps {
  status: VisitOccurrenceStatus;
}

export function VisitOccurrencesStatusPill(props: VisitOccurrencesStatusPillProps) {
  const { status } = props;
  if (status === VisitOccurrenceStatuses.APPROVED) {
    return (
      <Pill
        label="Approved"
        color={(theme) => theme.palette.intent?.success.text}
        backgroundColor={(theme) => theme.palette.intent?.success.background}
      />
    );
  }

  if (status === VisitOccurrenceStatuses.REJECTED) {
    return (
      <Pill
        label="Rejected"
        color={(theme) => theme.palette.intent?.error.text}
        backgroundColor={(theme) => theme.palette.intent?.error.background}
      />
    );
  }

  return (
    <Pill
      label="Pending approval"
      color={(theme) => theme.palette.intent?.neutral.text}
      backgroundColor={(theme) => theme.palette.intent?.neutral.background}
    />
  );
}
